import React from 'react';
import { EntityLayout, EntityLayoutProps } from '@backstage/plugin-catalog';
import { useIsAdmin } from '../auth';

/**
 * Wrapper de EntityLayout que oculta el menú de contexto para no-admins
 * El menú incluye acciones como "Unregister entity" que solo admins deberían poder usar
 */
const AdminEntityLayoutComponent: React.FC<EntityLayoutProps> = ({ 
  children, 
  UNSTABLE_contextMenuOptions,
  ...props 
}) => {
  const { isAdmin, loading } = useIsAdmin();

  if (loading) {
    return <EntityLayout {...props}>{children}</EntityLayout>;
  }

  // Si no es admin, deshabilitar Unregister
  const menuOptions = isAdmin 
    ? UNSTABLE_contextMenuOptions
    : { 
        ...UNSTABLE_contextMenuOptions,
        disableUnregister: true as const
      };

  return (
    <EntityLayout 
      {...props}
      UNSTABLE_contextMenuOptions={menuOptions}
    >
      {children}
    </EntityLayout>
  );
};

// Copiar la propiedad estática Route del EntityLayout original
export const AdminEntityLayout = Object.assign(AdminEntityLayoutComponent, {
  Route: EntityLayout.Route,
});

export default AdminEntityLayout;
